import React, { useMemo, useEffect, useState, useCallback } from 'react';
import { Row, Col } from 'reactstrap';

import VersionerDocumentComparisonItem from './item';
import VersionerDocumentComparisonSidebarPanel from './sidebar/panel';

import axios from 'axios';

const routes = () => {
  return {
    default: {
      createComparisonPath: Routes.versioner_document_comparisons_path,
      showComparisonPath: Routes.versioner_document_comparison_path,
      diffComparisonCurrentFilePath: Routes.diff_current_file_versioner_document_comparison_path,
      diffComparisonPreviousFilePath: Routes.diff_previous_file_versioner_document_comparison_path,
      showItemPath: Routes.versioner_document_thread_item_path
    },
    portal: {
      createComparisonPath: Routes.portal_versioner_document_comparisons_path,
      showComparisonPath: Routes.portal_versioner_document_comparison_path,
      diffComparisonCurrentFilePath: Routes.diff_current_file_portal_versioner_document_comparison_path,
      diffComparisonPreviousFilePath: Routes.diff_previous_file_portal_versioner_document_comparison_path,
      showItemPath: Routes.portal_versioner_document_thread_item_path
    }
  }
}

const getRoutes = (props) => {
  const {
    helpers: {
      isPortalContext
    }
  } = props

  let context = 'default';

  if(isPortalContext){
    context = 'portal';
  }

  return routes()[context];
}

const getRequestParams = props => {
  const {
    thread,
    configuration,
    helpers: {
      isPortalContext
    }
  } = props

  let requestParams = {
    thread_id: thread?.hashid
  }

  if(isPortalContext){
    requestParams = {
      tenant: configuration?.tenant,
      thread_id: thread?.hashid
    }
  }

  return requestParams;
}

const createComparisonService = async (endpoint, formData) => {
  const response = await axios({
    method: 'post',
    url: endpoint,
    data: formData,
    headers: {
      "X-CSRF-TOKEN": window.compliance.token
    }
  })
  return response;
}

const VersionerDocumentComparisonContainer = (props) => {
  const {
    thread,
    currentItem,
    previousItem,
    configuration,
    callbacks: {
      setThread: callbackOnSetThread
    },
    helpers: {
      isPortalContext,
      itemName: itemNameHelper
    }
  } = props;

  const {
    createComparisonPath,
    showComparisonPath,
    showItemPath,
    diffComparisonCurrentFilePath,
    diffComparisonPreviousFilePath
  } = getRoutes(props);

  const defaultRequestParams = getRequestParams(props);

  const comparison = useMemo(() => {
    return currentItem?.current_comparison;
  }, [currentItem])

  const isLoading = useMemo(() => {
    if(currentItem && previousItem){
      return !comparison;
    } else {
      return false
    }
  }, [comparison])

  useEffect(() => {
    if(currentItem?.current_comparison == null){
      createComparison()
    } else {
      console.error('Error in comparison')
    }
  }, [])

  const createComparison = useCallback(() => {
    if(!currentItem || !previousItem){
      return;
    }

    const formData = new FormData();

    formData.append('versioner_document_comparison[previous_item_id]', previousItem?.id);
    formData.append('versioner_document_comparison[current_item_id]', currentItem?.id);

    const route = createComparisonPath(
      {
        ...defaultRequestParams,
        format: "json", _options: true
      }
    )

    createComparisonService(route, formData).then(response => {
      callbackOnSetThread(prevState => {
        return {
          ...prevState,
          items: prevState?.items.map(item => {

            if(item?.id === currentItem?.id){
              return {
                ...item,
                current_comparison: response.data
              }
            }

            return item;
          })
        }
      })
    }).catch(error => {
      console.error('Error in comparison', error)
    })
  })

  const formattedCurrentItem = useMemo(() => {
    let _item = { ... currentItem }
    _item.name = itemNameHelper(currentItem);

    if(comparison?.id){
      _item.filePath = diffComparisonCurrentFilePath({ ...defaultRequestParams, id: comparison.id, format: 'pdf', _options: true })
    } else {
      _item.filePath = showItemPath({ ...defaultRequestParams, id: currentItem.id, format: 'pdf', _options: true })
    }

    return _item;
  }, [currentItem, comparison])

  const formattedPreviousItem = useMemo(() => {

    if(!previousItem){
      return {}
    }

    let _item = { ... previousItem }
    _item.name = itemNameHelper(previousItem);

    if(comparison?.id){
      _item.filePath = diffComparisonPreviousFilePath({ ...defaultRequestParams, id: comparison.id, format: 'pdf', _options: true })
    } else {
      _item.filePath = showItemPath({ ...defaultRequestParams, id: previousItem.id, format: 'pdf', _options: true })
    }
    return _item;
  }, [previousItem, comparison])

  return (
    <Row>
      <Col md={8} className="mb-4">
        <Row>
          {
            previousItem && (
              <Col md={6}>
                <VersionerDocumentComparisonItem
                  item={ formattedPreviousItem }
                  configuration={{
                    isLoading: isLoading
                  }}
                />
              </Col>
            )
          }
          <Col md={6}>
            <VersionerDocumentComparisonItem
              item={ formattedCurrentItem }
              configuration={{
                isLoading: isLoading
              }}
            />
          </Col>
        </Row>
      </Col>

      <Col md={4}>
        <VersionerDocumentComparisonSidebarPanel
          thread={thread}
          comparison={comparison}
          currentItem={currentItem}
          previousItem={previousItem}
          configuration={configuration}
          data={ props?.data }
          helpers={{
            itemName: itemNameHelper,
            isPortalContext: isPortalContext
          }}
          callbacks={{
            callbackOnSetThread: callbackOnSetThread
          }}
        />
      </Col>
    </Row>
  );
};

export default VersionerDocumentComparisonContainer;
